//se consultan las url del backend definido
let BACK_ORIGIN = typeof localStorage != 'undefined'?localStorage.getItem('BACK_URL'):''
let URL_ORIGIN = typeof localStorage != 'undefined'?localStorage.getItem('SERVER_URL'):''

//URL BACKEND
export const PYTHON_URL = BACK_ORIGIN+'/'
//URLS PLATAFORMA
export const SERVER_URL = URL_ORIGIN
export const FILE_SERVER_URL = `${URL_ORIGIN}/assets_ideep/fotos_formulario`